import {Query} from "../../../containers/HealthcareUsageReport/types/CohortQuery";
import {Tooltip} from "antd";
import styles from "./ExportButton.module.scss";
import React from "react";
import {buildStudyStatsRoute} from "../../../pages/routes";
import {useHistory} from "react-router-dom";
import {DescriptiveStats} from "../../cohort-navigation/icons/DescriptiveStats";
import {FINISHED_STATUS} from "../../../containers/CohortBuilder/cohortStatus";

export const ViewDescriptiveStatsButton = ({projectId, query }: { projectId: string | undefined, query: Query }) => {
    const history = useHistory()

    if (projectId === undefined || query.sparkQuery?.status?.toLowerCase() !== FINISHED_STATUS || !query.trackable) {
        return null;
    }

    const path = buildStudyStatsRoute(parseInt(projectId), query.id)

    return (
        <Tooltip title="view descriptive stats">
            <span
                className={styles['export-icon']}
                onClick={() => {
                    history.push(path)
                }}
            >
                <DescriptiveStats/>
            </span>
        </Tooltip>
    )
}